import { ActiveCoinData } from '../types/botServer';

/** Resolve the best DEX/platform label from active coin fields. */
export function resolveDexLabel(coin: Pick<ActiveCoinData, 'platform' | 'dex' | 'pool_type'>): string {
    return (coin.platform || coin.dex || coin.pool_type || '').trim();
}

/** Map DEX/platform name to a public logo path (solarba-bundler assets). */
export function getDexImagePath(dexLabel: string): string | null {
    const dexLower = dexLabel.toLowerCase().trim();
    if (!dexLower) return null;

    if (dexLower.includes('bags')) return '/bags.png';
    if (dexLower.includes('pumpfun') || dexLower === 'pump') return '/pumpfun.png';
    if (dexLower.includes('pumpswap')) return '/pumpswap.png';
    if (dexLower.includes('launchlab') || dexLower.includes('launch_lab')) return '/launchlab.png';
    if (dexLower.includes('meteoradbc') || dexLower.includes('dbc')) return '/meteoradbc.png';
    if (dexLower.includes('meteora')) return '/meteora.png';
    if (dexLower.includes('raydium')) return '/raydium.png';
    if (dexLower.includes('orca')) return '/orca.png';
    if (dexLower.includes('heaven')) return '/heaven.png';
    if (dexLower.includes('moonit')) return '/moonit.png';

    const normalized = dexLower.replace(/[^a-z0-9]/g, '');
    return normalized ? `/${normalized}.png` : null;
}

export function getActiveCoinDexImage(coin: Pick<ActiveCoinData, 'platform' | 'dex' | 'pool_type'>): {
    label: string;
    src: string | null;
} {
    const label = resolveDexLabel(coin);
    return {
        label,
        src: getDexImagePath(label),
    };
}
